export const ONBOARDING_CONTINUE_LATER_SWITCH = 'pro_onboarding_continue_fly4054_20230804';
export const PROVIDER_HOME_NEXT_BEST_ACTIONS_FLAG = 'pro_home_next_best_actions_fly4058_20230830';
